module.exports = __webpack_public_path__ + "fonts/iconfont.71c8cd8a.woff";